/**
 * Convert weight from grams/ml to kg/l
 */
export function convertWeight(weight, unit) {
  if (!unit) return weight;
  const unitLower = unit.trim().toLowerCase();
  if (unitLower === 'g' || unitLower === 'ml') {
    return parseFloat((weight / 1000).toFixed(2));
  }
  return parseFloat(weight.toFixed(0));
}

/**
 * Convert weight unit from g/ml to kg/l
 */
export function convertWeightUnit(unit) {
  if (!unit) return unit;
  const unitLower = unit.trim().toLowerCase();
  if (unitLower === 'g') return 'kg';
  if (unitLower === 'ml') return 'l';
  return unit;
}
